import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Smartphone } from "lucide-react";

const APP_STORE_URL = "https://apps.apple.com/app/aiapply/id0000000000";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.aiapply.app";

function detectStore() {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/iPhone|iPod|iPad/i.test(ua)) return { name: "App Store", url: APP_STORE_URL };
  if (/Android/i.test(ua)) return { name: "Google Play", url: PLAY_STORE_URL };
  return null;
}

export default function AppStoreBanner() {
  const [store, setStore] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("aiapply_banner_dismissed") === "1") { setDismissed(true); return; }
    setStore(detectStore());
  }, []);

  if (!store || dismissed) return null;

  return (
    <div className="bg-[#2D4A3E] text-white" data-testid="app-store-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3 px-4 py-2.5">
        <div className="flex items-center gap-2 min-w-0">
          <Smartphone className="w-4 h-4 shrink-0" />
          <div className="text-xs sm:text-sm truncate">
            <span className="font-semibold">Get JobKnocker on {store.name}</span>
            <span className="hidden sm:inline text-white/70"> · apply on the go, same account</span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link to={store.url} data-testid="app-store-banner-cta">
            <span className="text-xs sm:text-sm underline-offset-2 hover:underline font-medium">Open</span>
          </Link>
          <button
            aria-label="Dismiss"
            data-testid="app-store-banner-close"
            onClick={() => { localStorage.setItem("aiapply_banner_dismissed", "1"); setDismissed(true); }}
            className="p-1 rounded hover:bg-white/10 transition-colors">
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
